import { type ComponentProps, type ReactNode } from 'react';
import { FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import RegularCheckbox from 'components/Checkbox/RegularCheckbox';
import classNames from 'classnames';

const useStyles = makeStyles({
  label: extendedFormsStyle.label,
  labelDisabled: {
    cursor: 'not-allowed',
  },
  disabled: {
    cursor: 'not-allowed',
  },
});

type LabeledCheckboxProps = {
  label: ReactNode;
  className?: string;
  checked: boolean;
};

const LabeledCheckbox = ({
  className,
  label,
  checked,
  ...regularCheckboxProps
}: LabeledCheckboxProps & ComponentProps<typeof RegularCheckbox>) => {
  const classes = useStyles();

  const labelClassName = classNames(
    classes.label,
    regularCheckboxProps.disabled && classes.labelDisabled
  );

  return (
    <FormControlLabel
      className={className}
      classes={{
        label: labelClassName,
        disabled: classes.disabled,
      }}
      label={label}
      checked={!!checked}
      control={<RegularCheckbox {...regularCheckboxProps} />}
    />
  );
};

export default LabeledCheckbox;
